import { render } from "./PriceFilter.vue?vue&type=template&id=8ad972bc"
import script from "./PriceFilter.vue?vue&type=script&lang=js"
export * from "./PriceFilter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__